<template>
<section :class="classes">
	<Heading :level="1" text="Additional Documents" />
	<form @submit.prevent="saveAndSubmit" novalidate ref="form" class="view-wrap three-quarters">
		<HelpText classes="m-b-2">
			<template #text>
				<p>Please upload the following documents to support your application:</p>
			</template>
		</HelpText>

		<CheckboxField
			ref="ua_doccapitalgrantsupplementaryquestions"
			name="ua_doccapitalgrantsupplementaryquestions"
			label-text="Capital Grant Supplementary Questions"
			:value="formData.ua_doccapitalgrantsupplementaryquestions"
			:true-value="1"
			:false-value="2"
			@emitFieldData="(val) => formData.ua_doccapitalgrantsupplementaryquestions = val"
			required-error="Upload this file to proceed" />

		<CheckboxField
			ref="ua_financialappendicesspreadsheetuploaded"
			name="ua_financialappendicesspreadsheetuploaded"
			label-text="Completed Financial Appendices"
			:value="formData.ua_financialappendicesspreadsheetuploaded"
			:true-value="1"
			:false-value="2"
			@emitFieldData="(val) => formData.ua_financialappendicesspreadsheetuploaded = val"
			required-error="You must agree to this declaration to proceed" />

		<CheckboxField
			ref="ua_doclastyearfinancial"
			name="ua_doclastyearfinancial"
			label-text="Last year's audited financial statements (or year end accounts)"
			:value="formData.ua_doclastyearfinancial"
			:true-value="1"
			:false-value="2"
			@emitFieldData="(val) => formData.ua_doclastyearfinancial = val"
			required-error="You must agree to this declaration to proceed" />

		<CheckboxField
			ref="ua_doclatestmanagementaccounts"
			name="ua_doclatestmanagementaccounts"
			label-text="Latest management accounts"
			:value="formData.ua_doclatestmanagementaccounts"
			:true-value="1"
			:false-value="2"
			@emitFieldData="(val) => formData.ua_doclatestmanagementaccounts = val"
			required-error="You must agree to this declaration to proceed" />

		<CheckboxField
			ref="ua_docgroupaccounts"
			name="ua_docgroupaccounts"
			label-text="Group Accounts (if applicable)"
			:value="formData.ua_docgroupaccounts"
			:true-value="1"
			:false-value="2"
			@emitFieldData="(val) => formData.ua_docgroupaccounts = val"
			:is-required="false"
			required-error="You must agree to this declaration to proceed" />

		<CheckboxField
			ref="ua_docmonthlyprofitlossforecast"
			name="ua_docmonthlyprofitlossforecast"
			label-text="Monthly Profit & Loss Forecast"
			:value="formData.ua_docmonthlyprofitlossforecast"
			:true-value="1"
			:false-value="2"
			@emitFieldData="(val) => formData.ua_docmonthlyprofitlossforecast = val"
			required-error="You must agree to this declaration to proceed" />

		<CheckboxField
			ref="ua_doccashflowforecasts"
			name="ua_doccashflowforecasts"
			label-text="Cash flow forecasts for at least the next 12 months"
			:value="formData.ua_doccashflowforecasts"
			:true-value="1"
			:false-value="2"
			@emitFieldData="(val) => formData.ua_doccashflowforecasts = val"
			required-error="You must agree to this declaration to proceed" />

		<CheckboxField
			ref="ua_docdirectorcvs"
			name="ua_docdirectorcvs"
			label-text="CVs of directors and project management team"
			:value="formData.ua_docdirectorcvs"
			:true-value="1"
			:false-value="2"
			@emitFieldData="(val) => formData.ua_docdirectorcvs = val"
			required-error="You must agree to this declaration to proceed" />

		<FileUpload
			ref="additionalDocuments"
			name="additionalDocuments"
			:is-multi="true"
			@fileUploadErrors="(val) => fileUploadError = val"
			@uploadFiles="uploadFiles()"
			@emitFieldData="v => prepareFiles(v)"
			:upload-msg="uploadMsg"
			:is-required="getUploadedFiles && !getUploadedFiles.length"
			:uploaded-files="getUploadedFiles"
			label-text="Please the above documents"
			required-error="Please provide your evidence"
			:validation-rules="[rules.withinFileSizeLimit]" />
	</form>
</section>
</template>

<script>

import { formSteps } from '@/mixins/appFormSteps';
import { formValidator } from '@/mixins/formValidator';
import { fileUploads } from '@/mixins/fileUploads';
import { validationRules } from '@/utilities/validationRules';

export default {
	name: 'AdditionalDocuments',
	mixins: [formValidator, formSteps, fileUploads],
	props: {
		classes: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			rules: validationRules,
			noteSubject: 'OTHER_DOCUMENTS',
			formData: {
				ua_doccapitalgrantsupplementaryquestions: false,
				ua_financialappendicesspreadsheetuploaded: false,
				ua_doclastyearfinancial: false,
				ua_doclatestmanagementaccounts: false,
				ua_docgroupaccounts: false,
				ua_docmonthlyprofitlossforecast: false,
				ua_doccashflowforecasts: false,
				ua_docdirectorcvs: false
			}
		};
	},
	computed: {
		otherCriteriaValid () {
			if (this.isSoleTrader || this.isPartnership) {
				return (this.getUploadedFiles && this.getUploadedFiles.length);
			}
			return true;
		}
	}
};
</script>
